module.exports = __webpack_public_path__ + "img/2.8.TSS.97961951.png";